<mat-toolbar class="mat-elevation-z3">
  <h1 class="opus">OPUS</h1>
  <img alt="KCMGP Logo" src="assets/logo_KCMGP.png"/>
  <span class="spacer"></span>
  <mat-divider style="height: 50%" vertical></mat-divider>

  <div class="form-field-container">
    @if(isUserLoaded) {
      <mat-form-field class="custom-margin">
        <div matPrefix>
          <mat-icon>home_work</mat-icon>
        </div>
        <mat-label>Entité</mat-label>
        <mat-select [(ngModel)]="selectedEntity" (selectionChange)="onEntitySelect($event.value)">
          <mat-option *ngFor="let entity of entityWithProfiles" [value]="entity.entity">
            {{ entity.entity }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="custom-margin">
        <div matPrefix>
          <mat-icon>badge</mat-icon>
        </div>
        <mat-label>Profil</mat-label>
        <mat-select [(ngModel)]="selectedProfile" (selectionChange)="onProfileSelect($event.value)">
          <mat-option *ngFor="let profile of profiles" [value]="profile">
            {{ profile }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    }

    <div class="user-info" (click)="openEditDialog()">
      <div class="user-icon" matPrefix>{{ getInitials() }}</div>
      <mat-label>{{ currentUserLabel }}</mat-label>
    </div>
  </div>

  <mat-divider style="height: 50%" vertical></mat-divider>
  <div>
    <button aria-label="Example icon-button with heart icon" class="example-icon favorite-icon"
            mat-icon-button [matMenuTriggerFor]="notificationsMenu">
      <mat-icon [matBadge]="notificationsCount || null">notifications</mat-icon>
    </button>
    <mat-menu #notificationsMenu="matMenu">
      <ng-container *ngIf="notifications.length > 0; else noNotifications">
        <ng-container *ngFor="let notification of notifications | slice:0:5">
          <button mat-menu-item (click)="onNotificationClick(notification)"
                  [ngClass]="{'unread-notification': !notification.is_read}">
            {{ notification?.notification?.message! }}
          </button>
          <mat-divider></mat-divider>
        </ng-container>
      </ng-container>
      <ng-template #noNotifications>
        <button mat-menu-item disabled>
          Aucune notification
        </button>
      </ng-template>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="openNotificationsDialog()">
        Voir toutes les notifications
      </button>
    </mat-menu>
  </div>

  <button (click)="logout()" aria-label="Example icon-button with share icon" class="example-icon" mat-icon-button>
    <mat-icon>logout</mat-icon>
  </button>
</mat-toolbar>
